import DialogWrap from './DialogWrap';
import Panel from './Dialog/Content/Panel';
export { Panel };
export default DialogWrap;